module.exports = __webpack_public_path__ + "website/img/bg_co.8bee9f18.png";